import React from 'react';
import { DateRangeDropdownV2, FormFieldV2 as FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

// Options for the "Báo cáo theo" dropdown (without "Không nhóm" option)
const reportByOptions = [
  { value: 'customer', label: 'Khách hàng' },
  { value: 'customerGroup1', label: 'Nhóm khách 1' },
  { value: 'customerGroup2', label: 'Nhóm khách 2' },
  { value: 'customerGroup3', label: 'Nhóm khách 3' },
  { value: 'product', label: 'Vật tư' },
  { value: 'productGroup1', label: 'Nhóm vật tư 1' },
  { value: 'productGroup2', label: 'Nhóm vật tư 2' },
  { value: 'productGroup3', label: 'Nhóm vật tư 3' },
  { value: 'unit', label: 'Đơn vị' },
  { value: 'department', label: 'Bộ phận' },
  { value: 'project', label: 'Vụ việc' },
  { value: 'contract', label: 'Hợp đồng' },
  { value: 'agreement', label: 'Khế ước' },
  { value: 'fee', label: 'Phí' },
  { value: 'product', label: 'Sản phẩm' },
  { value: 'productionOrder', label: 'Lệnh sản xuất' },
  { value: 'employee', label: 'Nhân viên bán hàng' }
];

// Options for the "Nhóm theo" dropdown (includes "Không nhóm" option)
const groupByOptions = [{ value: 'no-group', label: 'Không nhóm' }, ...reportByOptions];

const BasicInfo: React.FC = () => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-1'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Kỳ này từ/đến:</Label>
          <div>
            <DateRangeDropdownV2 fromDateName='fromDate' toDateName='toDate' />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Kỳ trước từ/đến:</Label>
          <div>
            <DateRangeDropdownV2 fromDateName='previousFromDate' toDateName='previousToDate' />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Báo cáo theo:</Label>
          <div>
            <FormField name='reportBy' type='select' options={reportByOptions} className='w-32' />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Nhóm theo:</Label>
          <div>
            <FormField name='groupBy' type='select' options={groupByOptions} className='w-32' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
